import React from "react";
import Button from "./Button";
import Input from "./Input";

const EditNameModal = ({
  title,
  label,
  value,
  saveText = "Save",
  loading = false,
  onChange,
  onSave,
  onCancel,
}) => {
  const onSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  return (
    <div style={styles.overlay} onClick={loading ? undefined : onCancel}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.title}>{title}</h3>

        <form onSubmit={onSubmit}>
          <Input
            label={label}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Enter name"
            required
            autoFocus
          />

          <div style={styles.actions}>
            <Button variant="secondary" onClick={onCancel} disabled={loading} type="button">
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? "Saving..." : saveText}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1100,
    padding: 16,
  },
  modal: {
    width: "100%",
    maxWidth: 460,
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 8px 30px rgba(0,0,0,0.2)",
    padding: "22px 22px 18px",
  },
  title: {
    margin: "0 0 14px",
    fontSize: 18,
    fontWeight: 700,
    color: "#1e1e2d",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 6,
  },
};

export default EditNameModal;
